var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkupunturIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59998 22L8.59998 20V17H20.6M11.6 20H20.6M8.59998 14L11.6 12L12.6 8C15.6 9 15.6 12 15.6 14M3.59998 17C3.59998 17.2652 3.70533 17.5196 3.89287 17.7071C4.08041 17.8946 4.33476 18 4.59998 18C4.86519 18 5.11955 17.8946 5.30708 17.7071C5.49462 17.5196 5.59998 17.2652 5.59998 17C5.59998 16.7348 5.49462 16.4804 5.30708 16.2929C5.11955 16.1054 4.86519 16 4.59998 16C4.33476 16 4.08041 16.1054 3.89287 16.2929C3.70533 16.4804 3.59998 16.7348 3.59998 17ZM8.59998 5C8.59998 5.26522 8.70533 5.51957 8.89287 5.70711C9.08041 5.89464 9.33476 6 9.59998 6C9.86519 6 10.1195 5.89464 10.3071 5.70711C10.4946 5.51957 10.6 5.26522 10.6 5C10.6 4.73478 10.4946 4.48043 10.3071 4.29289C10.1195 4.10536 9.86519 4 9.59998 4C9.33476 4 9.08041 4.10536 8.89287 4.29289C8.70533 4.48043 8.59998 4.73478 8.59998 5Z",
    stroke: "#358888",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkupunturIcon);
export default __webpack_public_path__ + "static/media/akupuntur_icon.a0201163809050c93916f285fed09493.svg";
export { ForwardRef as ReactComponent };